import React, { useEffect, useState } from 'react';
import './EmployeeDatabase.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';
import { Space, Table, Tag } from 'antd';
import { useAuth } from '../../AuthContext';
import { API_URL } from '../../Config';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const EmployeeDatabase = () => {
  const navigate = useNavigate();
  const [isFormOpen, setIsFormOpen] = useState(false);
  const { user } = useAuth();
  const username = user.user;
  const [users, setUsers] = useState([]);

  useEffect(() => {
    let endpoint = API_URL + `/users/?filter=${username.username}`;

    if (username.role === 'Admin' || username.role === 'HR') {
      endpoint = API_URL + '/users';
    }
    fetch(endpoint)
      .then((response) => response.json())
      .then((data) => setUsers(data))
      .catch((error) => console.error(error));
  }, [username.username, username.role]);

  const fetchTasks = (filterValue) => {
    let endpoint;

    if (filterValue && (username.role === 'Admin' || username.role === 'HR')) {
      endpoint = `${API_URL}/users/?filter=${filterValue}`;
    } else if (filterValue) {
      endpoint = `${API_URL}/users/?filter=${filterValue}`;
    }
    else if (username.role === 'Admin' || username.role === 'HR') {
      endpoint = `${API_URL}/users`;
    } else {
      endpoint = `${API_URL}/users/?filter=${username.username}`;
    }
    fetch(endpoint)
      .then((response) => response.json())
      .then((data) => setUsers(data))
      .catch((error) => console.error(error));
  };

  const deleteUser = async (username) => {
    try {
      const response = await axios.delete(API_URL + `/users/${username}`);

      if (response.status === 204) {
        console.log('User deleted successfully');
        fetchTasks();
      } else {
        console.error('Error deleting User');
      }
    } catch (error) {
      console.error(error);
    }
  };

  //============= Add User =================================================================
  const [formData, setFormData] = useState({

    username: '',
    mobile: '',
    email: '',
    role: '',
    address: '',
    date_of_birth: '',
    blood_group: '',
    id_proof: '',
    id_proof_number: '',
    work_type: '',
    previous_work: '',
    previous_work_with: '',
    reference_name: '',
    password: '',
    confirm_password: '',
    total_task_count: '',
    total_distance_count: '',
    total_present_days_count: '',
    total_absent_days_count: '',
    uuId: '',
    manager: '',
    punch_In: '',
    punch_out: '',
    total_hour: '',
    profile: '',
    date_of_join: '',
  });
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  let work_type_data;
  let role_data;
  let manager_data;
  if(users && users.length > 0) {
    work_type_data = users.map(user => user.work_type).filter((value, index, self) => self.indexOf(value) === index);
    role_data = users.map(user => user.role).filter((value, index, self) => self.indexOf(value) === index);
    manager_data = users.map(user => user.manager).filter((value, index, self) => self.indexOf(value) === index);
  }
  

  const handleSubmit = (e) => {
    e.preventDefault();
    fetch(API_URL + '/registerUser', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('Form data sent successfully:', data);
        closeForm();
        fetchTasks();
      })
      .catch((error) => {
        console.error('Error sending form data:', error);
      });
  };

  //========================================================================================
  const getUserDetails = (username) => {
    const filteredUser = users.filter(user => user.username === username);
    navigate('/UserDetails', { state: { userDetails: filteredUser[0] } });
  };

  const openForm = () => {
    setIsFormOpen(true);
  };

  const closeForm = () => {
    setIsFormOpen(false);
  };

  const columns = [
    {
      title: 'Index',
      dataIndex: 'Index',
      key: 'Index',
      width: '8%',
    },
    {
      title: 'Name',
      dataIndex: 'Name',
      key: 'Name',
    },
    {
      title: 'Role',
      key: 'Role',
      dataIndex: 'Role',
      width: '14%',
      render: (_, { Role }) => (
        <>
          {Role.map((tag) => {
            let color = tag.length > 5 ? 'geekblue' : 'green';
            if (tag === 'Admin') {
              color = '#173452';
            }
            else if (tag === 'HR') {
              color = '#173452';
            }
            else if (tag === 'Manager') {
              color = '#b5cce8';
            }
            return (
              <Tag color={color} key={tag}>
                {tag.toUpperCase()}
              </Tag>
            );
          })}
        </>
      ),
    },
    {
      title: 'Manager',
      key: 'Manager',
      dataIndex: 'Manager',
    },
    {
      title: 'Phone No.',
      key: 'PhoneNo',
      dataIndex: 'PhoneNo',
      width: '15%',
    },
    {
      title: 'Email ID',
      dataIndex: 'EmailID',
      key: 'EmailID',
    },
    {
      title: 'Action',
      key: 'action',
      width: '10%',
      render: (_, record) => (
        <Space size="middle">
          <div onClick={() => getUserDetails(record.Name)}>
            <img className='search' src="../assets/pencil.png" alt="search" height={"24px"}></img>
          </div>
          <div onClick={() => deleteUser(record.Name)}>
            <img className='search' src="../assets/trash.png" alt="search" height={"23px"}></img>
          </div>
        </Space>
      ),
    },
  ];

  const dataa = (users && users.length > 0) ? users.map((item, index) => ({
    key: index.toString(),
    Index: index + 1,
    Name: item.username || '',
    Role: [item.role || ''],
    Manager: item.manager || '',
    PhoneNo: item.mobile || '',
    EmailID: item.email

  })) : [];

  return (
    <div className="employee_database_page">
      <SideMenuBar />

      <div className="content">
        <NewHeader />

        <main className="employee_database_container">
          <section className="employee_database_hero">
            <div>
              <span className="employee_database_kicker">People management</span>
              <h1 className="directory_Directory">Directory</h1>
              <p className="employee_database_subtitle">
                Manage employees, roles, managers and access from one central directory.
              </p>
            </div>

            <div className="employee_summary">
              <span>Total employees</span>
              <strong>{users.length}</strong>
              <small>Visible records</small>
            </div>
          </section>

          <section className="employee_toolbar">
            <div className="employee_toolbar_intro">
              <span className="section_eyebrow">Employee database</span>
              <strong>Team directory</strong>
            </div>

            <div className="employee_toolbar_actions">
              <label className="employee_search">
                <img src="../assets/search.png" alt="" />
                <input
                  placeholder="Search employees..."
                  aria-label="Search employees"
                  onChange={(e) => fetchTasks(e.target.value)}
                />
              </label>

              <button type="button" className="add_user_btn_EmployeeDatabase" onClick={openForm}>
                <span>+</span> Add employee
              </button>
            </div>
          </section>

          <section className="employee_database_panel">
            <header className="employee_database_panel_header">
              <div>
                <span className="section_eyebrow">Directory</span>
                <h2>All employees</h2>
              </div>
              <span className="employee_count_badge">{users.length} employees</span>
            </header>

            <div className="table_EmployeeDatabase">
              <Table
                className="modern_employee_table"
                columns={columns}
                dataSource={dataa}
                scroll={{ x: 860, y: 480 }}
                pagination={false}
              />
            </div>
          </section>
        </main>
      </div>

      {isFormOpen && (
        <>
          <div className="overlay_EmployeeDatabase" onClick={closeForm}></div>

          <section
            className="popup-form_EmployeeDatabase"
            role="dialog"
            aria-modal="true"
            aria-label="Add Employee"
          >
            <header className="employee_modal_header">
              <div>
                <span className="section_eyebrow">New record</span>
                <h2>Add Employee</h2>
                <p>Create an employee profile with personal, work and access information.</p>
              </div>

              <button
                type="button"
                className="close_EmployeeDatabase"
                onClick={closeForm}
                aria-label="Close"
              >
                ×
              </button>
            </header>

            <form
              className="employee_form"
              onSubmit={handleSubmit}
            >
              <div className="employee_form_section">
                <div className="employee_form_section_heading">
                  <span className="employee_section_number">01</span>
                  <div>
                    <h3>Personal information</h3>
                    <p>Basic contact and identity information.</p>
                  </div>
                </div>

                <div className="employee_form_grid">
                  <div className="employee_form_field">
                    <label>Full Name</label>
                    <input
                      placeholder="Enter full name"
                      name="username"
                      value={formData.username}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="employee_form_field">
                    <label>Phone No.</label>
                    <input
                      placeholder="Enter phone number"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="employee_form_field">
                    <label>Email ID</label>
                    <input
                      type="email"
                      placeholder="Enter email address"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="employee_form_field">
                    <label>Blood Group</label>
                    <input
                      placeholder="Enter blood group"
                      name="blood_group"
                      value={formData.blood_group}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="employee_form_field employee_form_field_full">
                    <label>Current Address</label>
                    <textarea
                      placeholder="Enter current address"
                      name="address"
                      value={formData.address}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="employee_form_field employee_form_field_full">
                    <label>Permanent Address</label>
                    <textarea placeholder="Enter permanent address" />
                  </div>

                  <div className="employee_form_field">
                    <label>Identity Proof Number</label>
                    <input
                      placeholder="Enter identity proof number"
                      name="id_proof_number"
                      value={formData.id_proof_number}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="employee_upload_field">
                    <label>Identity Proof</label>
                    <a className="a_of_uploadHere_EmployeeDatabase" href="/">
                      <img src="../assets/cloud_upload.png" alt="" />
                      <span>Upload identity proof</span>
                      <small>.jpg / .png</small>
                    </a>
                  </div>
                </div>
              </div>

              <div className="employee_form_divider" />

              <div className="employee_form_section">
                <div className="employee_form_section_heading">
                  <span className="employee_section_number">02</span>
                  <div>
                    <h3>Work &amp; access</h3>
                    <p>Role, reporting and account configuration.</p>
                  </div>
                </div>

                <div className="employee_form_grid">
                  <div className="employee_form_field">
                    <label>Work Type</label>
                    <select
                      name="work_type"
                      value={formData.work_type}
                      onChange={handleInputChange}
                    >
                      <option value="" disabled>Select work type</option>
                      {(work_type_data || []).map((workType, index) => (
                        <option key={index} value={workType}>{workType}</option>
                      ))}
                    </select>
                  </div>

                  <div className="employee_form_field">
                    <label>Role</label>
                    <select
                      name="role"
                      value={formData.role}
                      onChange={handleInputChange}
                    >
                      <option value="" disabled>Select role</option>
                      {(role_data || []).map((role, index) => (
                        <option key={index} value={role}>{role}</option>
                      ))}
                    </select>
                  </div>

                  <div className="employee_form_field">
                    <label>Manager</label>
                    <select
                      name="manager"
                      value={formData.manager}
                      onChange={handleInputChange}
                    >
                      <option value="" disabled>Select manager</option>
                      {(manager_data || []).map((manager, index) => (
                        <option key={index} value={manager}>{manager}</option>
                      ))}
                    </select>
                  </div>

                  <div className="employee_form_field">
                    <label>Referral Name</label>
                    <input
                      placeholder="Enter referral name"
                      name="reference_name"
                      value={formData.reference_name}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="employee_form_field">
                    <label>Date of Joining</label>
                    <input
                      type="date"
                      name="date_of_join"
                      value={formData.date_of_join}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="employee_form_field">
                    <label>User ID</label>
                    <input
                      placeholder="Enter user ID"
                      name="uuId"
                      value={formData.uuId}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="employee_form_field">
                    <label>Password</label>
                    <input
                      type="password"
                      placeholder="Enter password"
                      name="password"
                      value={formData.password}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="employee_form_field">
                    <label>Confirm Password</label>
                    <input
                      type="password"
                      placeholder="Confirm password"
                      name="confirm_password"
                      value={formData.confirm_password}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
              </div>

              <footer className="employee_form_footer">
                <button type="button" className="employee_form_cancel" onClick={closeForm}>
                  Cancel
                </button>
                <button type="submit" className="popup_form_addUser_EmployeeDatabase">
                  Add employee
                </button>
              </footer>
            </form>
          </section>
        </>
      )}
    </div>
  );
};

export default EmployeeDatabase;